import React, { useContext, useState } from 'react';
import TicketDetailsStep from './Steps/TicketDetailsStep';
import { GlobalContext } from 'providers/GlobalProvider';
import ShareStep from './Steps/ShareStep';
import { FileWithPath } from 'react-dropzone';
import LoadingStep from './Steps/LoadingStep';
import { Link, useHistory } from 'react-router-dom';
import { toBase64 } from 'utils/fileHelper';
import { useSnackbar } from 'notistack';
import CompleteStep from './Steps/CompleteStep';
import AutomationAPI from 'api/AutomationAPI';
import { format } from 'date-fns';
import CasesAPI from 'api/CasesAPI';
import ParamsStep from './Steps/ParamsStep';
import FileStep from './Steps/FileStep';
import pako from 'pako';
import { Buffer } from 'buffer';
import DataMatchStep from './Steps/DataMatchStep';
import { getNewDocs } from 'utils/resultsComparison';
import PaymentsAPI from 'api/PaymentsAPI';

interface value {
  searchVal: string,
  type: string,
}

interface IEntityState {
  fuzzy: boolean,
  dateRange: string[],
  lenses: string[],
  countries: string[],
  agencies: string[],
  lists: string[],
}

interface ICommodityState {
  fuzzy: boolean,
  dateRange: string[],
  comLenses: string[],
  comFilters: string[],
  chapters: string[],
  sections: string[],
  codes: string[],
  countries: string[],
  agencies: string[],
  lists: string[],
  hsCodeLists: string[],
}


export interface automationParams {
  values?: value[];
  entState?: IEntityState;
  comState?: ICommodityState;
  row?: string;
}

interface StepperState {
  autoName: string;
  setAutoName: any;
  type: string;
  setType: any;
  template: string[];
  setTemplate: any;
  file: FileWithPath | undefined;
  setFile: any;
  rows: any;
  setRows: any;
  cols: any;
  setCols: any;
  entFilters: any;
  setEntFilters: any;
  comFilters: any;
  setComFilters: any;
  entityState: any;
  setEntityState: any;
  commodityState: any;
  setCommodityState: any;
  frequency: string;
  setFrequency: any;
  shareWith: string[];
  setShareWith: any;
  selectedSourceBox: number;
  setSelectedSourceBox: any;
  cur_case: any;
  colsArr: any;
  setColsArr: any;
  screeningCus: any;
  userHasMonitor: boolean;
  }

  interface dataObj {
    type: string;
    searchVal: string;
    row: number;
  }

const Stepper: React.FC<StepperState> = (props: StepperState) => {
  const { autoName, setAutoName, type, setType, template, setTemplate, file, setFile, rows, setRows, cols, setCols, entFilters, setEntFilters, comFilters, setComFilters, entityState, commodityState, setEntityState, setCommodityState, frequency, setFrequency, shareWith, setShareWith, selectedSourceBox, setSelectedSourceBox, cur_case, colsArr, setColsArr, screeningCus, userHasMonitor } = props;

  const { enqueueSnackbar } = useSnackbar();
  const dt = new Date();
  const dtWithoutTz = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  const formatted_dt = format(dtWithoutTz, 'yyyy-MM-dd');

  const [ selectedRow, setSelectedRow ] = useState<number>(1);
  const [ completedState, setCompletedState ] = useState(false);
  const [ isSaveDisabled, setIsSaveDisabled ] = useState(false);
  const [ rowData, setRowData ] = useState([]);
  const [ ticketID, setTicketID ] = useState(null);

  const [ inputs, setInputs ] = useState<any>(
    {
      primary: cur_case?.entity?.primary ? cur_case?.entity?.primary : '',
      country: cur_case?.entity?.country ? cur_case?.entity?.country : '',
      address: cur_case?.entity?.address ? cur_case?.entity?.address : '',
      hsCode: cur_case?.commodity?.harmonizedScheduleCode ? cur_case.commodity.harmonizedScheduleCode : '',
      desc: cur_case?.commodity?.commodityName ? cur_case?.commodity?.commodityName : '',
      origin: cur_case?.commodity?.countryOfOrigin ? cur_case?.commodity?.countryOfOrigin : '',
      destination: cur_case?.commodity?.destinationCountry ? cur_case?.commodity?.destinationCountry : ''
    },
  );

  const [ saving, setSaving ] = useState(true);
  const [ tab, setTab ] = useState(cur_case?.docType.includes('Products') ? 'Products' : 'Entity');

  const handleRowClick = (rowIndex: number) => {
    setSelectedRow(rowIndex);
  };

  const handleSourceClick = (rowIndex: number) => {
    setSelectedSourceBox(rowIndex);
    setRowData([]);
    setFile(undefined);
    setCols([]);
    setRows([]);
    setInputs({
      primary: '',
      country: '',
      address: '',
      hsCode: '',
      desc: '',
      origin: '',
      destination: ''
    });
  };

  const handleNext = () => {
    if (selectedRow < 5) {
      if ((type !== 'Bulk Screening' || selectedSourceBox !== 1) && selectedRow === 2) {
        if (selectedSourceBox === 5 && selectedRow === 2) {
          updateRowsForSingleEntry();
        }
        setSelectedRow(4);
      } else {
        setSelectedRow(selectedRow + 1);
      }
    }
  };
  const handleBack = () => {
    if (selectedRow > 1) {
      if ((type !== 'Bulk Screening' || selectedSourceBox !== 1) && selectedRow === 4) {
        setSelectedRow(2);
      } else {
        setSelectedRow(selectedRow - 1);
      }
    }
  };
  const { cur_user } = useContext(GlobalContext);

  const history = useHistory();
  const goBack = () => {
    history.replace('/bite-monitor');
  };

  const updateRowsForSingleEntry = () => {
    const arr: any = [];

    if (inputs.primary?.length) {
      const obj = {
        type: 'entity',
        searchVal: inputs.primary,
        row: 1
      };
      arr.push(obj);
    }
    if (inputs.hsCode?.length) {
      const obj = {
        type: 'code',
        searchVal: inputs.hsCode,
        row: 1
      };
      arr.push(obj);
    } else if (inputs.desc?.length) {
      const obj = {
        type: 'desc',
        searchVal: inputs.desc,
        row: 1
      };
      arr.push(obj);
    }

    setRowData(arr);
  };

  const decompressData = (compressedData: any) => {
    const compressedBuffer = Buffer.from(compressedData[0], 'base64');
    const decompressed = pako.ungzip(compressedBuffer, { to: 'string' });
    return JSON.parse(decompressed);
  };

  const triggerMeter = async(): Promise<any> => {
    const res = await PaymentsAPI.updateMeter(
      {
        type: 'screening_forms_meter'
      },
      screeningCus.data.id
    );
    if (res?.success) {
      return res?.result;
    }
  };

  const autoAPICall = async(rowsArr: any) => {
    let allResults: any = [];
    let resCount = 0;
    let totalResults = 0;

    const findMatchingIndex = (val: string, arr: any[]): number | false => {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].field === val) {
          return i;
        }
      }
      return false;
    };

    for (const [ i, row ] of rowsArr.entries()) {
      const query: automationParams = {
        values: row,
        entState: entityState,
        comState: commodityState,
        row: i + 1,
      };

      const res = await AutomationAPI.automationDataSearch(query);
      resCount++;

      if (res?.success) {
        if (res?.result[0].result?.body?.hits?.total?.value) {
          totalResults = totalResults + res?.result[0].result?.body?.hits?.total?.value;
        }

        if (res?.result[1].result?.body?.hits?.total?.value) {
          totalResults = totalResults + res?.result[1].result?.body?.hits?.total?.value;
        }

        const entityResArr: any[] = [];
        const commodityResArr: any[] = [];

        await res?.result[0].result?.body?.hits?.hits?.forEach((hit: any) => {
          const val = hit.matched_queries ? hit.matched_queries[0] : '';
          const i = findMatchingIndex(val, entityResArr);
          if (i !== false) {
            entityResArr[i].hits++;
            entityResArr[i].docs.push(hit._source);
          } else {
            entityResArr.push({ field: val, row: res.result[0].row, dataSet: 'Entites', hits: 1, docs: [ hit._source ] });
          }
        });
        await res?.result[1].result?.body?.hits?.hits?.forEach((hit: any) => {
          const val = hit.matched_queries ? hit.matched_queries[0] : '';
          const i = findMatchingIndex(val, commodityResArr);
          if (i !== false) {
            commodityResArr[i].hits++;
            commodityResArr[i].docs.push(hit._source);
          } else {
            commodityResArr.push({ field: val, row: res.result[1].row, dataSet: 'Commodities', hits: 1, docs: [ hit._source ] });
          }
        });

        allResults = [ ...allResults, ...entityResArr, ...commodityResArr ];

        if (resCount === rowsArr.length) {
          triggerMeter();
          return {
            all: [ ...allResults ],
            tot: totalResults
          };
        };
      } else {
        const error_msg = 'Error screening data. An API call has failed or timed out.';
        enqueueSnackbar(error_msg, { variant: 'error' });
        return {
          all: [ ],
          tot: 0
        };
      }
    };
  };

  // BITE VAULT TICKET
  const handleTicket = async(values: any) => {
    setSaving(true);
    if (cur_case) {
      const update = {
        _id: cur_case._id,
        ...values.basics,
        ...values,
      };
      const resp = await CasesAPI.updateCase(update);

      if (resp?.success) {
        setTicketID(resp.result._id);
        setCompletedState(true);
        setSelectedRow(7);
        enqueueSnackbar('Successfully updated case', { variant: 'success' });
      } else if (resp) {
        const error_msg = 'Error updating case. Uploaded file(s) may be too large.';
        enqueueSnackbar(error_msg, { variant: 'error' });
      }
    } else {
      const new_case = {
        groupId: cur_user.selected_team.id,
        ...values.basics,
        ...values,
      };
      const resp = await CasesAPI.createCase({ newCase: new_case });

      if (resp?.success) {
        setTicketID(resp.result._id);
        setCompletedState(true);
        setSelectedRow(7);
        enqueueSnackbar('Successfully created new case', { variant: 'success' });
      } else if (resp) {
        const error_msg = 'Error saving new case. Uploaded file(s) may be too large.';
        enqueueSnackbar(error_msg, { variant: 'error' });
      }
    }
  };

  type Item = {
    type: string;
    searchVal: string;
    row?: number;
  };

  type InputArray = Item[][];

  type OutputArray = Item[][];

  const deduplicateObjects = (input: InputArray): OutputArray => {
    const seen = new Set<string>();

    return input.map((subArray) => {
      return subArray.filter((item) => {
        const key = `${item.type}-${item.searchVal}`;
        if (!seen.has(key)) {
          seen.add(key);
          return true;
        }
        return false;
      });
    });
  };

  const compressData = (data: any) => {
    const stringifiedData = JSON.stringify(data);
    const compressed = pako.gzip(stringifiedData);
    return Buffer.from(compressed).toString('base64'); // Convert to base64 for storage or transmission
  };

  const replaceOrReturn = (arr: any, newObj: any): any[] => {
    if (arr.length > 0) {
      arr[0] = newObj;
      return arr;
    }
    return [ newObj ];
  };


  const saveTicket = async() => {
    setSelectedRow(6);
    setIsSaveDisabled(true);
    let fileInfo = undefined;
    if (file) {
      const base64Str = await toBase64(file);
      fileInfo = {
        uploadedFile: {
          base64: base64Str,
          name: file?.name,
          dateAdded: Date.now(),
          source: true
        },
      };
    }

    const entFilterQuery = {
      lenses: entityState.lenses,
      countries: entityState.countries,
      agencies: entityState.agencies,
      lists: entityState.lists,
      entRes: entityState.fuzzy,
      filterDate: entityState.dateRange
    };

    const comFilterQuery = {
      lenses: commodityState.comLenses,
      countries: commodityState.countries,
      agencies: commodityState.agencies,
      lists: commodityState.lists,
      hsCodeLists: commodityState.hsCodeLists,
      sections: commodityState.sections,
      chapters: commodityState.chapters,
      codes: commodityState.codes,
      entRes: commodityState.fuzzy,
      filterDate: commodityState.dateRange
    };

    const ownerQuery = {
      kc_id: cur_user.basics?.id,
      email: cur_user.basics?.email,
      firstName: cur_user.basics?.firstName,
      lastName: cur_user.basics?.lastName,
    };

    const query: any = {
      documents: cur_case?.documents && cur_case?.documents.length > 0 ? replaceOrReturn(cur_case?.documents, fileInfo) : fileInfo,
      ticketName: autoName,
      lastUpdate: formatted_dt,
      entity: {
        primary: inputs.primary,
        country: inputs.country,
        address: inputs.address
      },
      commodity: {
        commodityName: inputs.desc,
        harmonizedScheduleCode: inputs.hsCode,
        countryOfOrigin: inputs.origin,
        destinationCountry: inputs.destination
      },
      docType: selectedSourceBox === 1 ? 'Multiple Entries' : tab === 'Entity' ? 'Single Entry - People / Companies' : 'Single Entry - Products',
      entityFilter: entFilterQuery,
      commodityFilter: comFilterQuery,
      frequency: frequency,
      sharedWith: shareWith,
      activeFilter: '',
      selectedOpts: [],
      status: (selectedSourceBox === 4 && rowData.length === 0) ? 'Pending Info' : 'Complete',
      favorite: cur_case?.favorite ? cur_case.favorite : false,
      groupName: cur_user.selected_team.name,
      template: template,
      colMapping: (selectedSourceBox === 1 && type === 'Bulk Screening') ? colsArr : [],
      activity: cur_case && cur_case.activity.length > 0 ? [ ...cur_case?.activity, {
        user: {
          kc_id: cur_user.basics?.id,
          email: cur_user.basics?.email,
          firstName: cur_user.basics?.firstName,
          lastName: cur_user.basics?.lastName,
        },
        action: 'resubmitted monitor ticket',
        timeStamp: Date.now()
      } ] : {
        user: {
          kc_id: cur_user.basics?.id,
          email: cur_user.basics?.email,
          firstName: cur_user.basics?.firstName,
          lastName: cur_user.basics?.lastName,
        },
        action:  'created monitor ticket',
        timeStamp: Date.now()
      }
    };

    if (!cur_case) {
      query.owner = ownerQuery;
    }

    if (rowData.length > 0 && selectedRow === 5) {
      setSaving(false);
      const updatedRows: any[] = [];
      rowData.map((obj: dataObj) => {
        if (obj.searchVal !== ' ') {
          const i = obj.row;
          if (i > updatedRows.length - 1) {
            updatedRows.push([ obj ]);
          } else {
            updatedRows[i].push(obj);
          }
        }
      });

      const uniqueRows = deduplicateObjects(updatedRows);

      const obj = await autoAPICall(uniqueRows);
      if (obj) {
        const newArr = cur_case && cur_case.results.length > 0 ? getNewDocs(decompressData(cur_case.results[cur_case.results.length - 1].allResults), obj.all) : [];

        const ticketQuery = {
          ...query,
          curTotal: obj.tot,
          curNew: newArr.length,
          results: cur_case && cur_case.results.length > 0 ? [ ...cur_case.results, {
            allResults: compressData(obj.all),
            allTotal: obj.tot,
            newResults: compressData(newArr),
            newTotal: newArr.length,
            date: formatted_dt,
            docInfo: uniqueRows
          } ] : {
            allResults: compressData(obj.all),
            allTotal: obj.tot,
            newResults: [],
            newTotal: 0,
            date: formatted_dt,
            docInfo: uniqueRows
          },
        };
        handleTicket(ticketQuery);
      }
    } else {
      handleTicket(query);
    }
  };

  return (
    <div className={`bill-row ${!userHasMonitor ? 'os-iframe-blur' : ''}`} >
      <div className='bill-container'>
        <div className='bill-container-header'>
          <div className='bill-container-header-bread-crumbs'>
            <div className='bill-container-header-bread-crumbs-tabs'>
              <Link to='/'>
                <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' cursor={'pointer'}>
                  <path d='M7.5 17.5V11.3333C7.5 10.8666 7.5 10.6333 7.59083 10.455C7.67072 10.2982 7.79821 10.1707 7.95501 10.0908C8.13327 9.99999 8.36662 9.99999 8.83333 9.99999H11.1667C11.6334 9.99999 11.8667 9.99999 12.045 10.0908C12.2018 10.1707 12.3293 10.2982 12.4092 10.455C12.5 10.6333 12.5 10.8666 12.5 11.3333V17.5M9.18141 2.30333L3.52949 6.69927C3.15168 6.99312 2.96278 7.14005 2.82669 7.32405C2.70614 7.48704 2.61633 7.67065 2.56169 7.86588C2.5 8.08627 2.5 8.32558 2.5 8.80421V14.8333C2.5 15.7667 2.5 16.2335 2.68166 16.59C2.84144 16.9036 3.09641 17.1585 3.41002 17.3183C3.76654 17.5 4.23325 17.5 5.16667 17.5H14.8333C15.7668 17.5 16.2335 17.5 16.59 17.3183C16.9036 17.1585 17.1586 16.9036 17.3183 16.59C17.5 16.2335 17.5 15.7667 17.5 14.8333V8.80421C17.5 8.32558 17.5 8.08627 17.4383 7.86588C17.3837 7.67065 17.2939 7.48704 17.1733 7.32405C17.0372 7.14005 16.8483 6.99312 16.4705 6.69927L10.8186 2.30333C10.5258 2.07562 10.3794 1.96177 10.2178 1.918C10.0752 1.87938 9.92484 1.87938 9.78221 1.918C9.62057 1.96177 9.47418 2.07562 9.18141 2.30333Z' stroke='#4895EF' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>
              </Link>
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#BDBEC1' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <p style={{ cursor: 'pointer' }} onClick={goBack}>Monitor</p>
              {
                cur_case?._id && (
                  <>
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                      <path d='M6 12L10 8L6 4' stroke='#BDBEC1' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round' />
                    </svg>
                    <Link to={{
                      pathname: `/monitor/ticket/${cur_case?._id}`,
                    }}>
                      <p style={{ cursor: 'pointer' }}>...</p>
                    </Link>
                  </>
                )
              }
              <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
                <path d='M6 12L10 8L6 4' stroke='#BDBEC1' strokeWidth='1.33333' strokeLinecap='round' strokeLinejoin='round'/>
              </svg>
              <p>{autoName}</p>
            </div>
          </div>
        </div>
        <div className='bill-container-body'>
          <div className={`bill-container-body-row ${selectedRow === 1 ? 'selected' : ''}`}
            onClick={() => handleRowClick(1)}
          >
            <div className={completedState ? 'bill-container-body-row-avatar-complete' : 'bill-container-body-row-avatar'}>
              {completedState ?
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <path d='M15 4.6875L6.75 12.9375L3 9.1875' stroke='#17B26A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg> :
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <path d='M6 6.1875V5.4375M6 9.5625V8.8125M6 12.9375V12.1875M5.1 15.1875H12.9C14.1601 15.1875 14.7902 15.1875 15.2715 14.9423C15.6948 14.7265 16.039 14.3823 16.2548 13.959C16.5 13.4777 16.5 12.8476 16.5 11.5875V6.7875C16.5 5.52738 16.5 4.89732 16.2548 4.41602C16.039 3.99266 15.6948 3.64845 15.2715 3.43274C14.7902 3.1875 14.1601 3.1875 12.9 3.1875H5.1C3.83988 3.1875 3.20982 3.1875 2.72852 3.43274C2.30516 3.64845 1.96095 3.99266 1.74524 4.41602C1.5 4.89732 1.5 5.52738 1.5 6.7875V11.5875C1.5 12.8476 1.5 13.4777 1.74524 13.959C1.96095 14.3823 2.30516 14.7265 2.72852 14.9423C3.20982 15.1875 3.83988 15.1875 5.1 15.1875Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>}
            </div>
            <div className='bill-container-body-row-frame'>
              <h1>Step 1: Ticket Details</h1>
            </div>
          </div>
          <div className='bill-container-body-row-line'>
            <svg xmlns='http://www.w3.org/2000/svg' width='2' height='12' viewBox='0 0 2 12' fill='none'>
              <path d='M1 0V12' stroke='#BDBEC1' strokeWidth='2'/>
            </svg>
          </div>
          <div className={`bill-container-body-row ${selectedRow === 2 ? 'selected' : ''}`}
            onClick={() => handleRowClick(2)}
          >
            <div className={completedState ? 'bill-container-body-row-avatar-complete' : 'bill-container-body-row-avatar'}>
              {completedState ?
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <path d='M15 4.6875L6.75 12.9375L3 9.1875' stroke='#17B26A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg> :
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <g clipPath='url(#clip0_26012_8210)'>
                    <path d='M12 9.1875L9 6.1875M9 6.1875L6 9.1875M9 6.1875V12.1875M16.5 9.1875C16.5 13.3296 13.1421 16.6875 9 16.6875C4.85786 16.6875 1.5 13.3296 1.5 9.1875C1.5 5.04536 4.85786 1.6875 9 1.6875C13.1421 1.6875 16.5 5.04536 16.5 9.1875Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                  </g>
                  <defs>
                    <clipPath id='clip0_26012_8210'>
                      <rect width='18' height='18' fill='white' transform='translate(0 0.1875)'/>
                    </clipPath>
                  </defs>
                </svg>}
            </div>
            <div className='bill-container-body-row-frame'>
              <h1>
                Step 2: {selectedSourceBox === 2 ? 'API Selection' : selectedSourceBox === 5 ? 'Entry Info' : 'File Upload'}
              </h1>
            </div>
          </div>
          <div className='bill-container-body-row-line'>

            <svg xmlns='http://www.w3.org/2000/svg' width='2' height='12' viewBox='0 0 2 12' fill='none'>
              <path d='M1 0V12' stroke='#BDBEC1' strokeWidth='2'/>
            </svg>

          </div>

          {(type === 'Bulk Screening' && selectedSourceBox === 1) &&
            <>
              <div className={`bill-container-body-row ${selectedRow === 3 ? 'selected' : ''}`}
                onClick={() => handleRowClick(3)}
              >
                <div className={completedState ? 'bill-container-body-row-avatar-complete' : 'bill-container-body-row-avatar'}>
                  {completedState ?
                    <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                      <path d='M15 4.6875L6.75 12.9375L3 9.1875' stroke='#17B26A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg> :
                    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='18' viewBox='0 0 16 18' fill='none'>
                      <path d='M9.5 15.1875C9.5 16.0159 8.82843 16.6875 8 16.6875C7.17157 16.6875 6.5 16.0159 6.5 15.1875M9.5 15.1875C9.5 14.3591 8.82843 13.6875 8 13.6875M9.5 15.1875H14.75M6.5 15.1875C6.5 14.3591 7.17157 13.6875 8 13.6875M6.5 15.1875H1.25M8 13.6875V10.6875M14.75 3.9375C14.75 5.18014 11.7279 6.1875 8 6.1875C4.27208 6.1875 1.25 5.18014 1.25 3.9375M14.75 3.9375C14.75 2.69486 11.7279 1.6875 8 1.6875C4.27208 1.6875 1.25 2.69486 1.25 3.9375M14.75 3.9375V8.4375C14.75 9.6825 11.75 10.6875 8 10.6875M1.25 3.9375V8.4375C1.25 9.6825 4.25 10.6875 8 10.6875' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                    </svg>}
                </div>
                <div className='bill-container-body-row-frame'>
                  <h1>Step 3: Data Matching</h1>
                </div>
              </div>
              <div className='bill-container-body-row-line'>
                <svg xmlns='http://www.w3.org/2000/svg' width='2' height='12' viewBox='0 0 2 12' fill='none'>
                  <path d='M1 0V12' stroke='#BDBEC1' strokeWidth='2'/>
                </svg>
              </div>
            </>
          }
          <div className={`bill-container-body-row ${selectedRow === 4 ? 'selected' : ''}`}
            onClick={() => handleRowClick(4)}
          >
            <div className={completedState ? 'bill-container-body-row-avatar-complete' : 'bill-container-body-row-avatar'}>
              {completedState ?
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <path d='M15 4.6875L6.75 12.9375L3 9.1875' stroke='#17B26A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg> :
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='18' viewBox='0 0 16 18' fill='none'>
                  <path d='M9.5 15.1875C9.5 16.0159 8.82843 16.6875 8 16.6875C7.17157 16.6875 6.5 16.0159 6.5 15.1875M9.5 15.1875C9.5 14.3591 8.82843 13.6875 8 13.6875M9.5 15.1875H14.75M6.5 15.1875C6.5 14.3591 7.17157 13.6875 8 13.6875M6.5 15.1875H1.25M8 13.6875V10.6875M14.75 3.9375C14.75 5.18014 11.7279 6.1875 8 6.1875C4.27208 6.1875 1.25 5.18014 1.25 3.9375M14.75 3.9375C14.75 2.69486 11.7279 1.6875 8 1.6875C4.27208 1.6875 1.25 2.69486 1.25 3.9375M14.75 3.9375V8.4375C14.75 9.6825 11.75 10.6875 8 10.6875M1.25 3.9375V8.4375C1.25 9.6825 4.25 10.6875 8 10.6875' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>}
            </div>
            <div className='bill-container-body-row-frame'>
              <h1>Step {(type === 'Bulk Screening' && selectedSourceBox === 1) ? 4 : 3}: Screening Parameters</h1>
            </div>
          </div>
          <div className='bill-container-body-row-line'>

            <svg xmlns='http://www.w3.org/2000/svg' width='2' height='12' viewBox='0 0 2 12' fill='none'>
              <path d='M1 0V12' stroke='#BDBEC1' strokeWidth='2'/>
            </svg>

          </div>
          <div className={`bill-container-body-row ${selectedRow === 5 ? 'selected' : ''}`}
            onClick={() => handleRowClick(5)}
          >
            <div className={completedState ? 'bill-container-body-row-avatar-complete' : 'bill-container-body-row-avatar'}>
              {completedState ?
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <path d='M15 4.6875L6.75 12.9375L3 9.1875' stroke='#17B26A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg> :
                <svg xmlns='http://www.w3.org/2000/svg' width='18' height='19' viewBox='0 0 18 19' fill='none'>
                  <path d='M7.87532 9.18759H3.75032M3.68683 9.40621L1.93564 14.6372C1.79806 15.0482 1.72928 15.2537 1.77864 15.3802C1.82151 15.4901 1.91358 15.5734 2.02719 15.6051C2.15802 15.6416 2.35562 15.5527 2.75082 15.3749L15.2844 9.73474C15.6702 9.56116 15.863 9.47436 15.9227 9.35379C15.9744 9.24904 15.9744 9.12613 15.9227 9.02138C15.863 8.90081 15.6702 8.81402 15.2844 8.64044L2.74645 2.99838C2.35244 2.82108 2.15544 2.73243 2.02474 2.76879C1.91124 2.80037 1.81917 2.88346 1.77616 2.99315C1.72662 3.11944 1.79468 3.32447 1.93078 3.73454L3.68732 9.02673C3.71069 9.09716 3.72238 9.13238 3.72699 9.16839C3.73109 9.20035 3.73105 9.23271 3.72687 9.26465C3.72216 9.30066 3.71039 9.33584 3.68683 9.40621Z' stroke='#4895EF' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
                </svg>}
            </div>
            <div className='bill-container-body-row-frame'>
              <h1>Step {(type === 'Bulk Screening' && selectedSourceBox === 1) ? 5 : 4}: Share with (Optional)</h1>
            </div>
          </div>
        </div>
      </div>
      <div className='bill-container-fit-screen' >
        <div className='bill-container-fit-screen-header'>
          <div className='bill-container-fit-screen-header-p'>
            {selectedRow === 1 ? (
              <p>Ticket Details</p>
            ) : (
              selectedRow === 2 ? (
                <p>{selectedSourceBox === 2 ? 'API Selection' : selectedSourceBox === 5 ? 'Entry Info' : 'File Upload'}</p>
              ) : (
                selectedRow === 3 ? (
                  <p>Data Matching</p>
                ) : (
                  selectedRow === 4 ? (
                    <p>Screening Parameters</p>
                  ) : (
                    selectedRow === 5 ? (
                      <p>Share With</p>
                    ) : (
                      <></>
                    )
                  )
                )
              )
            )}
          </div>
        </div>
        {selectedRow === 1 && (
          <TicketDetailsStep
            autoName={autoName}
            setAutoName={setAutoName}
            frequency={frequency}
            setFrequency={setFrequency}
            selectedSourceBox={selectedSourceBox}
            handleSourceClick={handleSourceClick}
            _id={cur_case?._id}
          />
        )}
        {selectedRow === 2 && (
          <FileStep
            template={template}
            setTemplate={setTemplate}
            type={type}
            setType={setType}
            file={file}
            setFile={setFile}
            rows={rows}
            setRows={setRows}
            setCols={setCols}
            rowData={rowData}
            setRowData={setRowData}
            cur_user={cur_user}
            selectedSourceBox={selectedSourceBox}
            setColsArr={setColsArr}
            inputs={inputs}
            setInputs={setInputs}
            _id={cur_case?._id}
            cur_case={cur_case}
            tab={tab}
            setTab={setTab}
          />
        )}
        {selectedRow === 3 && (
          <DataMatchStep
            rows={rows}
            setRowData={setRowData}
            colsArr={colsArr}
          />
        )}
        {selectedRow === 4 && (
          <ParamsStep
            entFilters={entFilters}
            setEntFilters={setEntFilters}
            comFilters={comFilters}
            setComFilters={setComFilters}
            cur_user={cur_user}
            entityState={entityState}
            setEntityState={setEntityState}
            commodityState={commodityState}
            setCommodityState={setCommodityState}
          />
        )}

        {selectedRow === 5 && (
          <ShareStep
            shareWith={shareWith}
            setShareWith={setShareWith}
          />
        )}
        {selectedRow === 6 && (
          <LoadingStep
            saving={saving}
          />
        )}
        {selectedRow === 7 && (
          <CompleteStep/>
        )}
        <div className='bill-container-footer'>
          <div className='bill-container-footer-btn'>
            {(selectedRow > 1 && selectedRow < 6) && <div className='bill-container-footer-btn-back' onClick={handleBack}>
                    Back
            </div>}
            {selectedRow < 5 && <div className='bill-container-footer-btn-next' onClick={handleNext}>
                    Next
            </div>}
          </div>
          {completedState ? (
            ticketID ? <Link to={`/monitor/ticket/${ticketID}`}>
              <div className='bill-container-footer-btn-submit-active'>
                <div className='bill-container-footer-btn-text-active'>
               View Ticket
                </div>
              </div>
            </Link> : <></>
          ) : selectedRow === 5 && rowData.length > 0 ? (
            <div className='bill-container-footer-btn-submit-active' onClick={saveTicket}>
              <div className='bill-container-footer-btn-text-active' >
                Submit
              </div>
            </div>
          ) : !isSaveDisabled && (
            <div className='bill-container-footer-btn-submit-active' onClick={saveTicket}>
              <div className='bill-container-footer-btn-text-active' >
                Save
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Stepper;
